import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterpageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
